<p-toast></p-toast>

<div class="flex justify-content-between flex-nowrap">
  <h5 class="align-self-center">Filter</h5>
  <button
    mat-icon-button
    (click)="closeDrawer.emit(true)"
    class="align-self-center"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-form-field class="w-full">
  <mat-label>Search Category here</mat-label>
  <input
    type="text"
    placeholder="Search Category here"
    matInput
    [formControl]="categoryFormControl"
    [matAutocomplete]="auto"
    [(ngModel)]="categorySelected"
  />
  <mat-icon matPrefix>search</mat-icon>
  <mat-autocomplete
    autoActiveFirstOption
    #auto="matAutocomplete"
    (optionSelected)="addCategorySelected($event)"
  >
    @if((filteredOptions | async)?.length === 0){
    <mat-option disabled>
      <mat-icon
        style="
          .material-symbols-outlined {
            font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
          }
        "
      >
        error
      </mat-icon>
      No matching category found.
    </mat-option>
    } @for(option of filteredOptions | async ;track option){
    <mat-option [value]="option">
      {{ option.Name }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>

<h6>Category</h6>
<mat-chip-listbox>
  @for(category of categorySelectedSet; track category){
  <mat-chip color="primary" selected (removed)="removeCategory(category)">
    {{ category.Name }}
    <button matChipRemove>
      <mat-icon>close</mat-icon>
    </button>
  </mat-chip>
  }
</mat-chip-listbox>

<h6>UOM</h6>
<div class="flex flex-column">
  <mat-radio-group *ngFor="let unit of uomCategories" [(ngModel)]="selectedUOM">
    <mat-radio-button color="primary" [value]="unit.value">{{ unit.name }}</mat-radio-button>
  </mat-radio-group>
</div>

<h6>Price</h6>
<div class="flex justify-content-center flex-wrap w-10">
  <mat-slider min="0" max="100" showTickMarks discrete class="flex">
    <input [(ngModel)]="min" matSliderStartThumb />
    <input [(ngModel)]="max" matSliderEndThumb />
  </mat-slider>
</div>

<div class="flex justify-content-center flex-nowrap w-full">
  <mat-form-field class="w-4 p-1">
    <mat-label>Min</mat-label>
    <input matInput [(ngModel)]="min" />
  </mat-form-field>

  <mat-form-field class="w-4 p-1">
    <mat-label>Max</mat-label>
    <input matInput [(ngModel)]="max" />
  </mat-form-field>
</div>

<mat-divider></mat-divider>

<div class="flex justify-content-left flex-nowrap gap-1 pt-1">
  <button mat-flat-button color="primary" (click)="apply()">Apply</button>
  <button mat-stroked-button color="" (click)="cancelFilter.emit(true)">Cancel</button>
</div>
